import { Disposable } from "../../../base/common/lifecycle";
import { IAnalyticsService } from "./analytics";



export abstract class BaseAnalyticsService extends Disposable implements IAnalyticsService {

    async initialize(): Promise<void> {
        // Override in subclasses if needed
    }

    logEvent(eventName: string, params?: { [key: string]: any; }): void {
        this.onLogEvent(eventName, params);
    }

    protected abstract onLogEvent(eventName: string, params?: { [key: string]: any; }): void;
}